import { render, staticRenderFns } from "./BannerContent.vue?vue&type=template&id=4ec68c5c&scoped=true&"
import script from "./BannerContent.vue?vue&type=script&lang=js&"
export * from "./BannerContent.vue?vue&type=script&lang=js&"
import style0 from "./BannerContent.vue?vue&type=style&index=0&id=4ec68c5c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec68c5c",
  null
  
)

export default component.exports